import type {AnalysisOptionProject} from "../AnalysisOptions.ts";
import type {Setter} from "../../../util/setter/Setter.ts";
import {useGroupProjectList} from "./useGroupProjectList.ts";
import Styles from "./ProjectSelection.module.scss";
import {SuspenseLayer} from "../../../util/suspense/SuspenseLayer.tsx";
import {useState} from "react";
import {VersionSelector} from "./VersionSelector.tsx";
import {ProjectIndicator} from "./ProjectIndicator.tsx";
import {combineStyles} from "../../../util/combineStyles.ts";

function isSelected(selected: { groupName: string, projectName: string } | undefined, groupName: string, projectName: string) {
    return selected !== undefined && selected.groupName === groupName && selected.projectName === projectName
}

interface Props {
    project: AnalysisOptionProject,
    setProject: Setter<AnalysisOptionProject>
}
export function ProjectSelector({project, setProject}: Props) {
    const groupProjects = useGroupProjectList()
    const [selectedProject, setSelectedProject] = useState<{ groupName: string, projectName: string } | undefined>(undefined)

    return <div className={Styles.ProjectSelector}>
        <div className={Styles.ProjectSelectionBlock}>
            {groupProjects.map(groupProject => <div className={Styles.Group} key={groupProject.groupName}>
                <div className={Styles.GroupName}>{groupProject.groupName}</div>
                <div className={Styles.Projects}>
                    {groupProject.projectNames.map(projectName => <div key={projectName}
                                                                       className={combineStyles(Styles.Project, isSelected(selectedProject, groupProject.groupName, projectName) && Styles.Project_Selected)}
                                                                       onClick={() => setSelectedProject({groupName: groupProject.groupName, projectName})}>
                        <span>{projectName}</span>
                        <ProjectIndicator groupName={groupProject.groupName} projectName={projectName}
                                          projectOptions={project} setProjectOptions={setProject}/>
                    </div>)}
                </div>
            </div>)}
        </div>
        <div className={Styles.VersionSelectionBlock}>
            <SuspenseLayer>
                <VersionSelector selectedProject={selectedProject} setSelectedProject={setSelectedProject}
                                 project={project} setProject={setProject} />
            </SuspenseLayer>
        </div>
    </div>
}